<template>
  <div class="order-detail-user">
    <div class="card special">
      <div class="title">合同信息</div>
      <div class="cell">
        <div class="li">合同编号</div>
        <div class="licontent">{{details.Code}}</div>
      </div>
      <div class="cell">
        <div class="li">下单时间</div>
        <div class="licontent">{{details.CreateTimeStr}}</div>
      </div>
      <div class="cell">
        <div class="li">合同押金</div>
        <div class="licontent">{{details.Deposit}}</div>
      </div>
      <div class="cell">
        <div class="li">合同租金</div>
        <div class="licontent">{{details.Price}}</div>
      </div>
      <div class="cell">
        <div class="li">状态</div>
        <div class="licontent" style="display: flex;justify-content: end;align-items: center" :style="{color: details.State === '进行中'? '#009C46' : '#EF941B'}">
          {{details.State}}
          <van-button @click="queryYy" type="primary" size="mini" style="margin-left: 10px;" v-if="details.State === '支付中'">查询支付状态</van-button>
        </div>
      </div>
      <div class="cell">
        <div class="li">校区</div>
        <div class="licontent">{{BizDormitoryInfo.RegionName}}</div>
      </div>
      <div class="cell">
        <div class="li">寝室</div>
        <div class="licontent">{{BizDormitoryInfo.FullAddress}}</div>
      </div>
      <div class="cell">
        <div class="li">备注</div>
        <div class="licontent">{{details.Remarks}}</div>
      </div>
    </div>
    <div class="card" v-if="BizPackageInfo">
      <div class="title">套餐信息</div>
      <div class="cell">
        <div class="li">套餐名称</div>
        <div class="licontent">{{BizPackageInfo.Name}}</div>
      </div>
      <div class="cell">
        <div class="li">押金</div>
        <div class="licontent">{{BizPackageInfo.Deposit}}</div>
      </div>
      <div class="cell">
        <div class="li">租金</div>
        <div class="licontent">{{BizPackageInfo.Price}}</div>
      </div>
      <div class="cell">
        <div class="li">结束时间</div>
        <div class="licontent">{{BizPackageInfo.EndTimeStr}}</div>
      </div>
      <van-divider></van-divider>
      <div style="text-align: right">
        总计：<span style="color: #EF941B">{{BizPackageInfo.Price+BizPackageInfo.Deposit}}</span>
      </div>
    </div>
    <div class="card" v-if="BizDormitoryInfo.BizEquipmentListInfos.length">
      <div class="title">设备信息</div>
      <div class="textarea">
        <div class="li">设备二维码</div>
        <div class="licontent">{{BizDormitoryInfo.BizEquipmentListInfos[0].QRCode}}</div>
      </div>
      <div class="textarea">
        <div class="li">设备SN号</div>
        <div class="licontent">{{BizDormitoryInfo.BizEquipmentListInfos[0].DeviceSn}}</div>
      </div>
      <div class="textarea">
        <div class="li">设备型号</div>
        <div class="licontent">{{BizDormitoryInfo.BizEquipmentListInfos[0].VersionFullName}}</div>
      </div>
      <div class="cell">
        <div class="li">设备类型</div>
        <div class="licontent" :style="{color: BizDormitoryInfo.BizEquipmentListInfos[0].Type === '空调'? '#EF941B' : '#009C46'}">{{BizDormitoryInfo.BizEquipmentListInfos[0].Type}}</div>
      </div>
      <div class="cell">
        <div class="li">设备状态</div>
        <div class="licontent" :style="{color: BizDormitoryInfo.BizEquipmentListInfos[0].State === '已安装'? '#009C46' : '#EF941B'}">{{BizDormitoryInfo.BizEquipmentListInfos[0].State}}</div>
      </div>
    </div>

    <div class="card">
      <div class="title">支付信息</div>
      <div class="orderlist" v-for="(itemInfo,index) in bizOrderListInfos" :key="index">
        <div class="cell">
          <div class="li">订单编号</div>
          <div class="licontent">{{itemInfo.Code}}</div>
        </div>
        <div class="cell">
          <div class="li">支付人</div>
          <div class="licontent">{{itemInfo.PayMemberName}}</div>
        </div>
        <div class="cell">
          <div class="li">订单状态</div>
          <div class="licontent">{{itemInfo.State}}</div>
        </div>
        <div class="cell">
          <div class="li">支付方式</div>
          <div class="licontent">{{itemInfo.PayType}}</div>
        </div>
        <div class="cell">
          <div class="li">支付时间</div>
          <div class="licontent">{{itemInfo.PayTimeStr}}</div>
        </div>
        <div class="cell">
          <div class="li">应支付金额</div>
          <div class="licontent">{{itemInfo.Money}}</div>
        </div>
        <div class="cell">
          <div class="li">应支付押金</div>
          <div class="licontent">{{itemInfo.EditDeposit}}</div>
        </div>
        <div class="cell">
          <div class="li">应支付租金</div>
          <div class="licontent">{{itemInfo.EditPrice}}</div>
        </div>
        <div class="cell" v-if="itemInfo.IsNeedPay" style="text-align: right;">
          <wx-pay :params="{Id: itemInfo.ParentOrderId}" @successPay="successPay" @refresh="refresh">
            <van-button type="primary" style="min-width:120px;padding:0 15px;border-radius: 5px;height:36px;display: inline-block">去支付 {{ itemInfo.PayAmount }}</van-button>
          </wx-pay>
        </div>
      </div>
    </div>
<!--    <dormitory-staff v-if="details.Id"></dormitory-staff>-->

    <div class="card">
      <div class="title">操作流程</div>
      <van-steps direction="vertical" :active="0">
        <van-step v-for="item in orderFlow" :key="item.Id" class="step-group-item">
          <div class="time">
            {{ item.CreateTimeStr }}
          </div>
          <div class="title">{{ item.CurrentName }}</div>
          <div class="text">
            {{ item.Text }}
          </div>
        </van-step>
      </van-steps>
    </div>



<!--    <div class="pay-btn" v-if="(details.State === '待支付' || details.State === '支付中') && details.IsOnline === true">-->
<!--      <wx-pay :params="{Id: details.ParentOrderId}" @successPay="successPay" @refresh="refresh">-->
<!--        <van-button type="primary" style="width: 100%;">去支付 {{ '￥' + details.PayAmount }}</van-button>-->
<!--      </wx-pay>-->
<!--    </div>-->
<!--    <div class="change_room" @click="openChange" v-if="details.IsEffective">更换寝室</div>-->


    <van-popup v-model="changeVisible" style="width: 100%;height: 100%" position="right" get-container="body">
      <change-room v-if="changeVisible" :order-info="details" is-popup @cancel="cancelChange" :all-member-list="allMemberList"></change-room>
    </van-popup>
    <van-popup v-model="yyDialogVisible" style="width: 100%;height: 100%" position="right" get-container="body">1</van-popup>
  </div>
</template>

<script>
import trSteps from '@/components/trSteps'
import wx from 'weixin-js-sdk'
import changeRoom from "@/views/user/userOrder/components/changeRoom.vue";
import dormitoryStaff from "@/views/modules/dormitoryStaff.vue";
import {setCookie} from "@/utils/cookie";
export default {
  name: 'orderDetails',
  data() {
    return {
      yyDialogVisible: false,
      ddd:{},
      allMemberList: [],
      changeVisible: false,
      showMemberList: false,
      ParentOrderDetails: {},
      orderFlow: [],
      details:{},
      BizDormitoryInfo:{},
      BizPackageInfo:{},
      bizOrderListInfos:[],
      // details: {
      //   BizDormitoryInfo: {
      //     BizEquipmentListInfos: []
      //   },
      //   BizOrderPackageInfo: {
      //     Name: '',
      //     Price: 0,
      //     CreateTimeStr: '0000-00-00',
      //     Deposit: 0,
      //     Code: 0,
      //   },
      //   BizMemberInfo: {
      //     Headimgurl: '',
      //     FullAddress: ''
      //   }
      // },
      orderId: '',
      // 代表是否可以换寝
      isAvailable: false,
    }
  },
  components: {
    trSteps,
    changeRoom,
    dormitoryStaff
  },
  methods: {
    async queryYy() {
      this.$toast.loading({
        mask: true,
        message: '查询中...',
        duration: 200000
      });
      try {
        const { Data, Status } = await this.$post('/BizMemberOrder/YyOrderQueryByOrderNew', { Id: this.details.bizOrderListInfos[0].Id })
        this.$toast.loading().clear()
        if(Status === 1) {
          this.$dialog.alert({
            title: '甬易订单',
            message: `甬易流水号：${Data.tradeNo || ''}\n支付金额（元）：${Data.tradeAmountDecimal || ''}\n支付状态：${Data.tradeStatusStr || ''}${Data.payFinishTimeStr ? `\n支付完成时间：${Data.payFinishTimeStr}` : ''}${Data.tradeStatus === 'FAIL' ? `\n失败原因：${Data.failReason}` : ''}`,
            messageAlign: 'left'
          }).then(() => {
            this.getDetails()
          })
        }
      }catch (e) {
        this.$toast.loading().clear()
      }
      // this.$toast.loading().clear()

    },
    async getAlLMemberData() {
      // const params = {
      //   ParentOrderId: this.ParentOrderDetails.Id,
      //   PageIndex:1,
      //   PageSize: 1000
      // }
      try {
        const {Data} = await this.$post('/BizMemberMember/MemberListNotI', {})
        this.allMemberList = Data
      } catch (e) {

      }
    },
    cancelChange(type){
      if (type === 'refresh') {
        this.getDetails()
      }
      this.changeVisible = false
    },
    openChange() {
      this.changeVisible = true
    },
    getOrderFlow() {
      this.$post('/BizMemberOrderFlow/AllListByParentOrder', {ParentOrderId: this.orderId}).then(res => {
        if (res) {
          this.orderFlow = res.Data
        }
      })
    },
    successPay(val) {
      this.$toast.loading().clear()
      if (val === 'chooseWXPay:ok') {
        this.$dialog.alert({
          message: '订单支付成功！'
        }).then(() => {
          this.getDetails()
        })
      } else {
        this.$toast.fail('支付失败！');
      }
    },
    getDetails() {
      this.$toast.loading({
        mask: true,
        message: '加载中...'
      });
      this.showMemberList = false
      this.$post('/BizMemberParentOrder/Details', {Id: this.orderId}).then(res => {
        if (res) {
          this.$toast.clear()
          this.details = res.Data
          this.ParentOrderDetails = res.Data
          this.ddd = res.Data
          this.BizDormitoryInfo = res.Data.BizDormitoryInfo
          this.BizPackageInfo = res.Data.BizPackageInfo
          this.bizOrderListInfos = res.Data.bizOrderListInfos
          this.getAlLMemberData()
          this.showMemberList = true
          console.log(this.details)
        }
      })
    },
    refresh(){
      setTimeout(() => {
        this.getDetails()
        this.getOrderFlow()
      }, 2000)
    }
  },
  created() {
    this.orderId = this.$route.query.Id ? this.$route.query.Id : 'ef123ee6-37e5-42a9-a8cb-839066cfe37b'
  },
  mounted() {
    this.getDetails()
    this.getOrderFlow()
  }
}
</script>

<style lang="less" scoped>
.order-detail-user{
  padding-bottom: 50px;

  .card{
    margin: 0.2rem;
    background-color: #fff;
    border-radius: 8px;
    padding: 15px;
    color: #3D3D3D;
    .orderlist{
      border-bottom: 4px solid #eee;padding:10px 0;
    }
    .orderlist:last-child{
        border-bottom:none;
    }

    &.special{
      .li{
        width: 60px!important;
      }
    }

    .title{
      color: #333333;
      display: flex;
      font-size: 18px;
      font-weight: bold;
      align-items: center;
    }

    .cell {
      display: flex;
      margin-top: 10px;
      width: 100%;

      >div{
        width: 100%;

        &.li{
          width: 100px;
          flex-shrink: 0;
        }
        &.licontent{
          text-align: right;
        }

        .li-tag{
          display: inline-block;
          color: #ffffff;
          padding: 3px 8px;
          border-radius: 4px;
        }
      }
    }

    .textarea{
      margin-top: 10px;
      .licontent{
        margin: 5px 0;
        background-color: #FAFAFA;
        padding: 10px;
        word-break: break-all;
        border-radius: 8px;
      }
    }
  }

  .step-group-item{
    .time{
      font-size: 12px;
      background-color: rgba(246, 246, 246);
      color: rgba(174, 174, 174);
      border-radius: 10px;
      padding: 2px 15px;
    }
    .title{
      font-size: 14px!important;
      margin: 15px 0 10px 0;
      color: #333333;
    }
    .text{
      font-size: 14px;
      word-break: break-all;
      color: rgba(174, 174, 174);
      line-height: 20px;
    }
  }

  .pay-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
  }

  .change_room {
    position: fixed;
    bottom: 0;
    height: 48px;
    line-height: 48px;
    text-align: center;
    width: 100%;
    left: 0;
    background: #48bd4b;
    color: #fff;
  }
}

</style>
